import { Box, Typography, ButtonBase } from "@mui/material"
import { FC, FCWC } from ".."
import { FilmFestivalLogo, GowayLogo, Container } from ".."
import filmFestivalGlobals from "./assets/filmFestivalGlobals.json"

const FilmFestivalFooter = ({ handleOpenTermsModal }: { handleOpenTermsModal: () => void }) => {
  return (
    <FooterContainer>
      <Container maxWidth={1400}>
        <Box
          display="grid"
          gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr 1fr" }}
          gap={{ xs: 14, md: 5 }}
          alignItems={{ xs: "center", md: "end" }}
        >
          <FilmFestivalLogo variant="secondary" />
          <FooterLinks handleOpenTermsModal={handleOpenTermsModal} />
          <Box
            display="flex"
            gap={5}
            alignItems="center"
            justifyContent={{ xs: "space-between", md: "end" }}
          >
            <GowayLogo variant="secondary" sx={{ width: 100 }} />
            <Typography
              variant="link.sm"
              sx={{
                color: (theme) => theme.palette["tertiary.800"].main,
              }}
            >
              {filmFestivalGlobals.footer.copyright}
            </Typography>
          </Box>
        </Box>
      </Container>
    </FooterContainer>
  )
}

export default FilmFestivalFooter

// A sub-component for the footer container
const FooterContainer: FCWC = ({ children }) => {
  return (
    <Box
      sx={(theme) => ({
        bgcolor: theme.palette["primary.800"].main,
        padding: { xs: theme.spacing(16, 3, 3), md: theme.spacing(30, 10, 10) },
        transition: theme.transitions.create(["padding"]),
        position: "relative",
        zIndex: 3,
      })}
    >
      {children}
    </Box>
  )
}

// A sub-component for the footer links
const FooterLinks: FC<{ handleOpenTermsModal: () => void }> = ({ handleOpenTermsModal }) => {
  return (
    <Box display="flex" gap={{ xs: 5, md: 10 }} justifyContent={{ xs: "start", md: "center" }}>
      {filmFestivalGlobals.footer.links.map((link) => (
        <ButtonBase key={link.label} onClick={handleOpenTermsModal}>
          <Typography
            variant="link.sm"
            sx={{ color: (theme) => theme.palette["tertiary.800"].main }}
          >
            {/* {link.label} */}
          </Typography>
        </ButtonBase>
      ))}
    </Box>
  )
}
